import React from 'react';
import { ReactComponent as Cash } from '../../assets/svg/cash.svg';
import { ReactComponent as Payid } from '../../assets/svg/payid.svg';
import { ReactComponent as Bank } from '../../assets/svg/bank.svg';
import { ReactComponent as Paypal } from '../../assets/svg/paypal.svg';
import { ReactComponent as Success } from '../../assets/svg/success.svg';
import { ReactComponent as Warning } from '../../assets/svg/warning.svg';
import { ReactComponent as Error } from '../../assets/svg/error.svg';
import { ReactComponent as Alert } from '../../assets/svg/alert.svg';
import { ReactComponent as ArrowLeft } from '../../assets/svg/arrowLeft.svg';
import { ReactComponent as ArrDown } from '../../assets/svg/arrDown.svg';
import { ReactComponent as Close } from '../../assets/svg/close.svg';
import { ReactComponent as Calendar } from '../../assets/svg/calendar.svg';
import { ReactComponent as Download } from '../../assets/svg/download.svg';
import { ReactComponent as Checkbox } from '../../assets/svg/checkbox.svg';
import { ReactComponent as CheckboxSelected } from '../../assets/svg/checkboxSelected.svg';
import { ReactComponent as Refresh } from '../../assets/svg/refresh.svg';
import { ReactComponent as Delete } from '../../assets/svg/delete.svg';
import { ReactComponent as Search } from '../../assets/svg/search.svg';
import { ReactComponent as Eye } from '../../assets/svg/eye.svg';
import { ReactComponent as List } from '../../assets/svg/list.svg';
import { ReactComponent as Stars } from '../../assets/svg/stars.svg';
import { ReactComponent as Question } from '../../assets/svg/question.svg';
import { ReactComponent as Loading } from '../../assets/svg/loading.svg';

type IconNames =
  | 'Cash'
  | 'Payid'
  | 'Bank'
  | 'Paypal'
  | 'Success'
  | 'Warning'
  | 'Error'
  | 'Alert'
  | 'ArrDown'
  | 'Close'
  | 'Calendar'
  | 'Download'
  | 'Checkbox'
  | 'CheckboxSelected'
  | 'Refresh'
  | 'Delete'
  | 'Search'
  | 'Eye'
  | 'List'
  | 'Stars'
  | 'Question'
  | 'Loading'
  | 'ArrowLeft';

type SvgComponent = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & { name: IconNames; title?: string }
>;

const SvgIcon: SvgComponent = ({ name, ...props }) => {
  const ICON_MAP = {
    Cash,
    Payid,
    Bank,
    Paypal,
    Success,
    Error,
    Warning,
    Alert,
    ArrDown,
    Close,
    Calendar,
    Download,
    Checkbox,
    CheckboxSelected,
    Refresh,
    Delete,
    Search,
    Eye,
    List,
    Stars,
    Question,
    ArrowLeft,
    Loading
  };

  const Icon = ICON_MAP[name as IconNames];
  return Icon ? (
    <Icon {...props} className={`svg-icon ${props.className || ''}`} />
  ) : null;
};

export default SvgIcon;
